// wp-icons — Drop-in custom icon library for WerkPilot
// API identical to lucide-react: <IconName size strokeWidth className color absoluteStrokeWidth />
// 24×24 viewBox, stroke=currentColor, round caps, default strokeWidth=2.
// Usage (React): import { User, Mail, Phone } from './wp-icons';
//         <User size={20} strokeWidth={1.75} className="text-[#378ab2]" />

import React, { forwardRef } from 'react';

const defaultAttrs = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

// Factory matching lucide's createLucideIcon signature
export const createWpIcon = (iconName, iconNode) => {
  const Component = forwardRef(
    (
      { color = 'currentColor', size = 24, strokeWidth = 2, absoluteStrokeWidth, className = '', children, ...rest },
      ref
    ) => {
      const attrs = {
        ...defaultAttrs,
        width: size,
        height: size,
        stroke: color,
        strokeWidth: absoluteStrokeWidth
          ? (Number(strokeWidth) * 24) / Number(size)
          : strokeWidth,
        className: ['wp-icon', `wp-icon-${iconName}`, className].filter(Boolean).join(' '),
        ref,
        ...rest,
      };
      return React.createElement(
        'svg',
        attrs,
        ...iconNode.map(([tag, props]) => React.createElement(tag, props)),
        ...(Array.isArray(children) ? children : children ? [children] : [])
      );
    }
  );
  Component.displayName = iconName;
  return Component;
};

export default createWpIcon;
